module.exports = __webpack_public_path__ + "img/IV-23.1bca5858.svg";